module.exports = __webpack_public_path__ + "static/assets/c854d56ddf2da31f8f94fa274f66c8ba.png";